// src/app/views/pages_admin/user_group/userGroup-routes.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const Sys = Loadable(lazy(() => import("./Sys")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `/sys`,
  element: <Sys />
}));

export default routes;